import React from 'react'

const About = () => {
  return (
    <div className="mace-about">
      <h4>About</h4>
      <p>
        Mace is a furniture store that makes its own furnitures for sale at retail stores. The store offer a wide range of domestic furnitures including tables, chairs that are suited for households. Mace also designs furnitures ideal for workplaces and schools. <br />
        The company has been expanding its capacity in recent years and has a target of spanning across many countires in the very near future.
      </p>
    </div>
  )
}

export default About